import axios from 'axios';
import Api from '../api/ApiUrl';

const API_URL = `${Api}/api/v1/admin`;
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
export const getAdmins = async () => {
  const response = await axios.get(API_URL,config);
  return response.data.data.admins;
};

export const getAdminById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`,config);
  return response.data.data.admin;
};

export const createAdmin = async (adminData) => {
  const response = await axios.post(API_URL, adminData,config);
  return response.data.data.admin;
};

export const updateAdmin = async ({ id, ...adminData }) => {
  const response = await axios.patch(`${API_URL}/${id}`, adminData,config);
  return response.data.data.admin;
};

export const deleteAdmin = async (id) => {
  await axios.delete(`${API_URL}/${id}`,config);
};

// export const addPermissionToAdmin = async (adminId, permissionId) => {
//   const response = await axios.post(`${API_URL}/${adminId}/permissions`, { permissionId });
//   return response.data.data.admin;
// };

// export const removePermissionFromAdmin = async (adminId, permissionId) => {
//   const response = await axios.delete(`${API_URL}/${adminId}/permissions/${permissionId}`);
//   return response.data.data.admin;
// };
export const addPermissionsToAdmin = async ({ adminId, permissionIds }) => {
    const response = await axios.post(`${API_URL}/${adminId}/permissions`, { permissionIds },config);
    return response.data.data.admin;
  };
  
  export const removePermissionFromAdmin = async ({ adminId, permissionId }) => {
    const response = await axios.delete(`${API_URL}/${adminId}/permissions/${permissionId}`,config);
    return response.data.data.admin;
  };